/* FR Fencing - "Ajouter au panier" button shows unit price x quantity, live-updated.
   Written without regex or non-ASCII so the theme upload stays byte-safe. */
(function () {
  function money(cents, fmt) {
    cents = Math.round(cents);
    var open = fmt.indexOf('{' + '{');
    var close = fmt.indexOf('}' + '}');
    var name = (open === -1 || close === -1) ? 'amount_with_comma_separator' : fmt.slice(open + 2, close).trim();

    var decimals = 2, thousands = '.', decimal = ',';
    if (name === 'amount') { decimals = 2; thousands = ','; decimal = '.'; }
    else if (name === 'amount_no_decimals') { decimals = 0; thousands = ','; decimal = '.'; }
    else if (name === 'amount_with_comma_separator') { decimals = 2; thousands = '.'; decimal = ','; }
    else if (name === 'amount_no_decimals_with_comma_separator') { decimals = 0; thousands = '.'; decimal = ','; }
    else if (name === 'amount_with_apostrophe_separator') { decimals = 2; thousands = "'"; decimal = '.'; }
    else if (name === 'amount_with_space_separator') { decimals = 2; thousands = ' '; decimal = ','; }
    else if (name === 'amount_no_decimals_with_space_separator') { decimals = 0; thousands = ' '; decimal = ','; }

    var fixed = (cents / 100).toFixed(decimals);
    var dot = fixed.indexOf('.');
    var intPart = dot === -1 ? fixed : fixed.slice(0, dot);
    var fracPart = dot === -1 ? '' : fixed.slice(dot + 1);

    var grouped = '', cnt = 0;
    for (var i = intPart.length - 1; i >= 0; i--) {
      grouped = intPart.charAt(i) + grouped;
      cnt++;
      if (cnt % 3 === 0 && i > 0) grouped = thousands + grouped;
    }
    var num = grouped + (decimals > 0 && fracPart ? decimal + fracPart : '');
    if (open === -1 || close === -1) return num;
    return fmt.slice(0, open) + num + fmt.slice(close + 2);
  }

  function init(root) {
    if (!root || root.dataset.frAtcPriceBound === '1') return;
    var btn = root.querySelector('.product-form__submit');
    if (!btn) return;
    root.dataset.frAtcPriceBound = '1';

    var fmtEl = root.querySelector('[data-fr-money-format]');
    var fmt = '{' + '{amount_with_comma_separator}}' + String.fromCharCode(0x20AC);
    if (fmtEl) { try { var parsed = JSON.parse(fmtEl.textContent); if (parsed) fmt = parsed; } catch (e) {} }

    var unitPrice = parseInt(btn.getAttribute('data-fr-unit-price'), 10);
    var addLabel = btn.getAttribute('data-fr-add-label') || '';

    function qty() {
      var qi = root.querySelector('.quantity__input') || root.querySelector('[name="quantity"]');
      var q = qi ? parseInt(qi.value, 10) : 1;
      return (isNaN(q) || q < 1) ? 1 : q;
    }
    function render() {
      if (isNaN(unitPrice)) return;
      var el = btn.querySelector('[data-fr-atc-total]');
      if (!el) return;
      el.innerHTML = money(unitPrice * qty(), fmt);
    }
    // After a variant change, Dawn (product-form.js) rewrites the button label to plain
    // add-to-cart text, so we re-append " . total price".
    function rebuildAfterVariant(variant) {
      var span = btn.querySelector('span');
      if (!span) return;
      if (!variant || variant.available === false) return; // sold out: keep Dawn's text
      if (typeof variant.price === 'number') unitPrice = variant.price;
      if (!span.querySelector('[data-fr-atc-total]')) {
        var label = (window.variantStrings && window.variantStrings.addToCart) || addLabel || span.textContent.trim();
        span.innerHTML = label + ' &middot; <span data-fr-atc-total></span>';
      }
      render();
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) render();
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) render();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data) rebuildAfterVariant(event.data.variant);
        });
      }
      if (PUB_SUB_EVENTS.quantityUpdate) {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, render);
      }
    }
    render();
  }

  function boot() {
    var roots = document.querySelectorAll('product-info');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
